module.exports = __webpack_public_path__ + "img/jihe2.46fe3807.png";